import {styled} from "@mui/material/styles"
import {ResponsiveColumns} from "../../../ResponsiveColumns"

export const StyledResponsiveColumns = styled(ResponsiveColumns)`
    margin-bottom: 1rem;
`
